import axios from "axios";

const createSalesItemsForTour = async (token, tourId) => {
  const path = `${process.env.REACT_APP_BACKEND_API_URL}/tours/${tourId}/sales`;
  try {
    const response = await axios.post(path, null, {
      headers: {
        Authorization: "Bearer " + token,
      },
    });
    return response;
  } catch (error) {
    console.log(error.response);
    return error.response;
  }
}

export default createSalesItemsForTour;